<template>
  <v-container fluid greybgright>
  <v-toolbar app color="white" id="topbar" class="hidden-sm-and-down">
   <v-toolbar-title v-if="branddata.brand"><img class="logo" v-bind:src="'https://manage.msa.airportdirecttravel.com/uploads/'+branddata.brand.brand_logo"></v-toolbar-title>
      <v-toolbar-items >
        <v-btn
          flat
          v-for="item in menuItems"
          :key="item.title"
          :to="item.path">
          <v-icon left dark>{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
      </v-toolbar-items>
</v-toolbar>
	  <v-expansion-panel class="hidden-md-and-up">
    <v-expansion-panel-content>
      <div slot="header" v-if="branddata.brand"><img class="logo" v-bind:src="'https://manage.msa.airportdirecttravel.com/uploads/'+branddata.brand.brand_logo"></div>
	  <div slot="header" v-else>
	  Menu
	  </div>
	   <v-btn
          flat left  
          v-for="item in menuItems"
          :key="item.title"
          :to="item.path">
          <v-icon left dark>{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
	</v-expansion-panel-content>
  </v-expansion-panel> 
  
<v-container grid-list-md >
    <v-layout row wrap>
		<v-flex md9  mt-2 mb-5>
		
        <h2 class="pagetitle">Manage My Booking</h2>
		<v-layout row wrap>
		<v-flex xs12  mt-1 mr-2 pb-1 pt-1 pl-1 pr-1>
	<p>Welcome to 'Manage My Booking', where you can view your booking, submit your APIS information (where required).</p>
	<p><strong>Please Note: </strong> If you are travelling with 72 hours, please call our customer services team on <strong v-if="branddata.brand">{{this.branddata.brand.brand_ephone}}</strong></p> 
	<hr class="grey mt-2 mb-2"/>
	<v-layout row wrap>
    <v-btn color="yourbookingnumber"><v-layout row wrap><v-flex md9 text-xs-left>Your Booking Reference</v-flex><v-flex md3>{{ bookingnumber }}</v-flex></v-layout></v-btn>
	</v-layout>
   <hr class="grey mt-2 mb-2"/>
  	</v-flex>
		</v-layout>
		
		<v-layout row wrap >
		<v-flex xs12  mt-1 mr-2 pb-1 pt-1 pl-1 pr-1 >
		<h3 class="mb-3  mt-2">Price Details</h3>
		<v-layout row wrap pt-2 pl-2 mr-1 whitewithborder>
		<v-flex xs10  mt-2 mb-2>
		<v-layout row wrap>
		
		<v-flex md3 xs6 v-if="bookingdata.Flights.Flight"><strong>Flights</strong></v-flex>
		<v-flex md9 xs6 v-if="bookingdata.Flights.Flight">&pound;{{ bookingdata.Flights.Flight.Price }}</v-flex>
		
		<v-flex md3 xs6 v-if="bookingdata.BookingAdjustments.BookingAdjustment"><strong>{{ bookingdata.BookingAdjustments.BookingAdjustment.AdjustmentType }}</strong></v-flex>
		<v-flex md9 xs6 v-if="bookingdata.BookingAdjustments.BookingAdjustment">&pound;{{ bookingdata.BookingAdjustments.BookingAdjustment.AdjustmentAmount }}</v-flex>
		
		<v-flex md3 xs6 v-if="bookingdata.Properties.Property"><strong>Accommodation</strong></v-flex>
		<v-flex md9 xs6 v-if="bookingdata.Properties.Property">&pound;{{ bookingdata.Properties.Property.TotalPrice }}</v-flex>
		
		<v-flex md3 xs6 v-if="bookingdata.Transfers.Transfer"><strong>Resort Transfers</strong></v-flex>
		<v-flex md9 xs6 v-if="bookingdata.Transfers.Transfer">&pound;{{ bookingdata.Transfers.Transfer.Price }}</v-flex>
		
		<v-flex md3 xs6 v-if="bookingdata.Extras.Extra"><strong>{{bookingdata.Extras.Extra.ExtraType}}</strong></v-flex>
		<v-flex md9 xs6 v-if="bookingdata.Extras.Extra">&pound;{{ bookingdata.Extras.Extra.TotalPrice }}</v-flex>
		
		<v-flex md3 xs6><strong>Total Price</strong></v-flex>
		<v-flex md9 xs6>&pound;{{ bookingdata.TotalPrice }}</v-flex>		
		<v-flex md3 xs6><strong>Total Paid</strong></v-flex>
		<v-flex md9 xs6>&pound;{{ bookingdata.TotalPaid }}</v-flex>		
		<v-flex md3 xs6><strong>Balance</strong></v-flex>
		<v-flex md9 xs6>&pound;{{ bookingdata.TotalOutstanding }}</v-flex>
		</v-layout>
		</v-flex>
		<v-flex xs2 text-md-right text-xs-center  mt-2 mb-2 shopping_cart>
		<v-icon>shopping_cart</v-icon>
		</v-flex>
		</v-layout>
		</v-flex>
		</v-layout>
		
		<v-layout row wrap >
		<v-flex xs12  mt-1 mr-2 pb-1 pt-2 pl-1 pr-1 >
		<h3 class="mb-3  mt-2">Lead Passenger Details</h3>
		<v-layout row wrap pt-2 pl-2 mr-1 whitewithborder>
		<v-flex xs10  mt-2 mb-2>
		<v-layout row wrap>
		<v-flex md3 xs3><strong>Name</strong></v-flex>
		<v-flex md9 xs9 upper>{{ bookingdata.LeadCustomer.CustomerTitle }}. {{ bookingdata.LeadCustomer.CustomerFirstName }} {{ bookingdata.LeadCustomer.CustomerLastName }}</v-flex>
		<v-flex md3 xs3><strong><v-icon>contacts</v-icon></strong></v-flex>
		<v-flex md9 xs9>{{ bookingdata.LeadCustomer.CustomerAddress1 }} <span v-if="typeof bookingdata.LeadCustomer.CustomerAddress2.length!=='undefined'">{{ bookingdata.LeadCustomer.CustomerAddress2 }}</span> {{ bookingdata.LeadCustomer.CustomerTownCity }} {{ bookingdata.LeadCustomer.CustomerPostcode }} </v-flex>		
		<v-flex md3 xs3><strong><v-icon>contact_phone</v-icon></strong></v-flex>
		<v-flex md9 xs9>{{ bookingdata.LeadCustomer.CustomerPhone }}</v-flex>		
		<v-flex md3 xs3><strong><v-icon>contact_mail</v-icon></strong></v-flex>
		<v-flex md9 xs9>{{ bookingdata.LeadCustomer.CustomerEmail }}</v-flex>		

		</v-layout>
		</v-flex>
		<v-flex xs2 text-md-right text-xs-center mt-2 mb-2 perm_identity>
		<v-icon>perm_identity</v-icon>
		</v-flex>
		</v-layout>
		</v-flex>
		</v-layout>
		
		<div v-if="bookingdata.Flights.Flight">
		<v-layout row wrap >
		<v-flex xs12 mt-1 mr-2 pb-1 pt-1 pl-1 pr-1 >
		<h3 class="mb-3 mt-2">Flight Passengers </h3>
		<div v-if="typeof bookingdata.Flights.Flight.FlightPassengers.FlightPassenger.length!=='undefined'">
		<v-layout row wrap pt-1 pl-2 mt-2 mr-1 whitewithborder v-for="(item, index) in bookingdata.Flights.Flight.FlightPassengers.FlightPassenger">
		<v-flex xs10  mt-1 mb-1>
		<v-layout mt-1 mb-1 row wrap >
		<v-flex md3 xs6><strong>Passenger</strong></v-flex>
		<v-flex  md9 xs6>{{index+1}}</v-flex>
		<v-flex md3 xs6><strong>Name</strong></v-flex>
		<v-flex  md9 xs6 upper>{{item.Title}} {{item.FirstName}} <span v-if="typeof item.MiddleName.length!=='undefined'">{{item.MiddleName}}</span> {{item.LastName}}</v-flex>
		<v-flex md3 xs6><strong>DOB</strong></v-flex>
		<v-flex md9 xs6>{{reformatDate(item.DateOfBirth)}}</v-flex>
		</v-layout>
		</v-flex>
		<v-flex xs2 text-md-right text-xs-center mt-1 mb-1 perm_identity>
		<v-icon>perm_identity</v-icon>
		</v-flex>
		</v-layout>

		</div>
		<div v-else>
		
		<v-layout row wrap pt-1 pl-2 mr-1 whitewithborder >
		<v-flex xs10  mt-1 mb-1>
		<v-layout mt-1 mb-1 row wrap >
		<v-flex md3 xs6><strong>Passenger</strong></v-flex>
		<v-flex md9 xs6>1</v-flex>
		<v-flex md3 xs6><strong>Name</strong></v-flex>
		<v-flex md9 xs6 upper>{{bookingdata.Flights.Flight.FlightPassengers.FlightPassenger.Title}} {{bookingdata.Flights.Flight.FlightPassengers.FlightPassenger.FirstName}} <span v-if="typeof bookingdata.Flights.Flight.FlightPassengers.FlightPassenger.MiddleName.length!=='undefined'">{{bookingdata.Flights.Flight.FlightPassengers.FlightPassenger.MiddleName}}</span> {{bookingdata.Flights.Flight.FlightPassengers.FlightPassenger.LastName}}</v-flex>
		<v-flex md3 xs6><strong>DOB</strong></v-flex>
		<v-flex md9 xs6>{{reformatDate(bookingdata.Flights.Flight.FlightPassengers.FlightPassenger.DateOfBirth)}}</v-flex>
		</v-layout>
		</v-flex>
		<v-flex xs2 text-md-right text-xs-center mt-1 mb-1 perm_identity>
		<v-icon>perm_identity</v-icon>
		</v-flex>
		</v-layout>

		</div>
		</v-flex>
		</v-layout>
		
		
		<v-layout row wrap >
		<v-flex xs12   mt-1 mr-2 pb-1 pt-1 pl-1 pr-1 >
		<h3 class="mb-3 mt-2">Flight Schedule</h3>
		<div v-if="typeof bookingdata.Flights.Flight.FlightSectors.FlightSector.length!=='undefined'">
		<v-layout row wrap pt-1 pl-2 mt-2 mr-1 whitewithborder v-for="(item, index) in bookingdata.Flights.Flight.FlightSectors.FlightSector">
		<v-flex xs10  mt-1 mb-1>
		<v-layout mt-1 mb-1 row wrap >
		<v-flex md3 xs6><strong>Carrier</strong></v-flex>
		<v-flex md9 xs6>{{item.FlightCarrier}}</v-flex>
		<v-flex md3 xs6><strong>Flight Number</strong></v-flex>
		<v-flex md9 xs6 upper>{{item.FlightCode}} </v-flex>
		<v-flex md3 xs6><strong>Departing</strong></v-flex>
		<v-flex md9 xs6>{{item.DepartureAirport}} ({{item.DepartureAirportCode}}) </v-flex>
		<v-flex md3 xs6><strong>Date and Time</strong></v-flex>
		<v-flex md9 xs6>{{reformatDaterfc(item.DepartureDate) | moment("dddd, Do [of] MMMM YYYY [at]")}} {{item.DepartureTime}}</v-flex>  
		<v-flex md3 xs6><strong>Arriving</strong></v-flex>
		<v-flex md9 xs6>{{item.ArrivalAirport}} ({{item.ArrivalAirportCode}})</v-flex>		
		<v-flex md3 xs6><strong>Date and Time</strong></v-flex>
		<v-flex md9 xs6>{{reformatDaterfc(item.ArrivalDate) | moment("dddd, Do [of] MMMM YYYY [at]")}} {{item.ArrivalTime}}</v-flex>
		</v-layout>
		</v-flex>
		<v-flex xs2 text-md-right text-xs-center mt-1 mb-1 perm_identity>
		<v-icon>flight_takeoff</v-icon>
		</v-flex>
		</v-layout>

		</div>
		<div v-else>
		
		<v-layout row wrap pt-1 pl-2 mr-1 whitewithborder >
		<v-flex xs10  mt-1 mb-1>
		<v-layout mt-1 mb-1 row wrap >
		<v-flex md3 xs6><strong>Carrier</strong></v-flex>
		<v-flex md9 xs6>{{bookingdata.Flights.Flight.FlightSectors.FlightSector.FlightCarrier}}</v-flex>
		<v-flex md3 xs6><strong>Flight Number</strong></v-flex>
		<v-flex md9 xs6 upper>{{bookingdata.Flights.Flight.FlightSectors.FlightSector.FlightCode}} </v-flex>
		<v-flex md3 xs6><strong>Departing </strong></v-flex>
		<v-flex md9 xs6>{{bookingdata.Flights.Flight.FlightSectors.FlightSector.DepartureAirport}} ({{bookingdata.Flights.Flight.FlightSectors.FlightSector.DepartureAirportCode}})</v-flex>
		<v-flex md3 xs6><strong>Date and Time </strong></v-flex>
		<v-flex md9 xs6>{{reformatDaterfc(bookingdata.Flights.Flight.FlightSectors.FlightSector.DepartureDate) | moment("dddd, Do [of] MMMM YYYY [at]")}} {{bookingdata.Flights.Flight.FlightSectors.FlightSector.DepartureTime}}</v-flex>
		<v-flex md3 xs6><strong>Arriving</strong></v-flex>
		<v-flex md9 xs6>{{bookingdata.Flights.Flight.FlightSectors.FlightSector.ArrivalAirport}} ({{bookingdata.Flights.Flight.FlightSectors.FlightSector.ArrivalAirportCode}})</v-flex>
		<v-flex md3 xs6><strong>Date and Time</strong></v-flex>
		<v-flex md9 xs6>{{reformatDaterfc(bookingdata.Flights.Flight.FlightSectors.FlightSector.ArrivalDate) | moment("dddd, Do [of] MMMM YYYY [at]")}} {{bookingdata.Flights.Flight.FlightSectors.FlightSector.ArrivalTime}}</v-flex>
		
		</v-layout>
		</v-flex>
		<v-flex xs2 text-md-right text-xs-center mt-1 mb-1 perm_identity>
		<v-icon>flight_takeoff</v-icon>
		</v-flex>
		</v-layout>

		</div>
		</v-flex>
		</v-layout>
		
		
		
		</div>
		
		<div v-if="bookingdata.Properties.Property">
		<v-layout row wrap mt-2 >
		<v-flex xs12   mt-1 mr-2 pb-1 pt-1 pl-1 pr-1 >	
		<h3 class="mb-3 mt-2">Accommodation Details</h3> 
		<v-layout row wrap pt-1 pl-2 mr-1 whitewithborder>
		<v-flex xs10  mt-1 mb-1>
		<v-layout mt-1 mb-1 row wrap >
		
		<v-flex md3 xs6><strong>Supplier</strong></v-flex><v-flex md9 xs6>{{bookingdata.Properties.Property.Source}}</v-flex>
		<v-flex md3 xs6><strong>Reference</strong></v-flex><v-flex md9 xs6>{{bookingdata.Properties.Property.SourceReference}}</v-flex>
		<v-flex md3 xs6><strong>Property</strong></v-flex><v-flex md9 xs6>{{bookingdata.Properties.Property.PropertyName}}, {{bookingdata.Properties.Property.GeographyLevel2Name}}</v-flex>
		<v-flex md3 xs6><strong>Check In</strong></v-flex><v-flex md9 xs6>{{reformatDate(bookingdata.Properties.Property.ArrivalDate)}}</v-flex>
		<v-flex md3 xs6><strong>Check Out</strong></v-flex><v-flex md9 xs6>{{reformatDate(bookingdata.Properties.Property.ReturnDate)}}</v-flex>
		</v-layout>
		</v-flex>
		<v-flex xs2 text-md-right text-xs-center mt-1 mb-1 perm_identity>
		<v-icon>hotel</v-icon>
		</v-flex>
		</v-layout>
		
		</v-flex>
		</v-layout>	
		
<v-layout row wrap mt-2 >
		<v-flex xs12   mt-1 mr-2 pb-1 pt-1 pl-1 pr-1 >	
		<h3 class="mb-3 mt-2">Room Details</h3> 
		<v-layout row wrap pt-1 pl-2 mr-1 whitewithborder>
		<v-flex xs10  mt-1 mb-1>
		<v-layout mt-1 mb-1 row wrap >
		
		<v-flex  md3 xs6><strong>Room Type</strong></v-flex><v-flex md9 xs6>{{bookingdata.Properties.Property.Rooms.Room.RoomType}}</v-flex>		
<v-flex  md3 xs6><strong>Meal Basis</strong></v-flex><v-flex md9 xs6>{{MealBasis[bookingdata.Properties.Property.Rooms.Room.MealBasisID].t}}</strong></v-flex>			
<v-flex  md3 xs6><strong>Adults</strong></v-flex><v-flex md9 xs6>{{bookingdata.Properties.Property.Rooms.Room.Adults}} </v-flex>		
<v-flex  md3 xs6><strong>Children</strong></v-flex><v-flex md9 xs6>{{bookingdata.Properties.Property.Rooms.Room.Children}}  </v-flex>		
<v-flex  md3 xs6><strong>Infants</strong></v-flex><v-flex md9 xs6>{{bookingdata.Properties.Property.Rooms.Room.Infants}}  </v-flex>	
		</v-layout>
		</v-flex>
		<v-flex xs2 text-md-right text-xs-center mt-1 mb-1 perm_identity>
		<v-icon>hotel</v-icon>
		</v-flex>
		</v-layout>
		
		</v-flex>
		</v-layout>	
		
		  
<v-layout row wrap >
		<v-flex xs12   mt-1 mr-2 pb-1 pt-1 pl-1 pr-1 >
		<h3 class="mb-3 mt-2">Guest Details</h3>
		<div v-if="typeof bookingdata.Properties.Property.Rooms.Room.GuestDetails.GuestDetail.length!=='undefined'">
		<v-layout row wrap pt-1 pl-2 mt-2 mr-1 whitewithborder v-for="(item, index) in bookingdata.Properties.Property.Rooms.Room.GuestDetails.GuestDetail">
		<v-flex xs10  mt-1 mb-1>
		<v-layout mt-1 mb-1 row wrap >
		<v-flex md3 xs6><strong>Name</strong></v-flex><v-flex md9 xs6>{{item.Title}} {{item.FirstName}} {{item.LastName}}</v-flex>
		<v-flex md3 xs6><strong>Age</strong></v-flex><v-flex md9 xs6>{{item.Type}}</v-flex>
		</v-layout>
		</v-flex>
		<v-flex xs2 text-md-right text-xs-center mt-1 mb-1 perm_identity>
		<v-icon>perm_identity</v-icon>
		</v-flex>
		</v-layout>

		</div>
		<div v-else>
		
		<v-layout row wrap pt-1 pl-2 mr-1 whitewithborder >
		<v-flex xs10  mt-1 mb-1>
		<v-layout mt-1 mb-1 row wrap >
		<v-flex md3 xs6><strong>Name</strong></v-flex><v-flex md9 xs6>{{bookingdata.Properties.Property.Rooms.Room.GuestDetails.GuestDetail.Title}} {{bookingdata.Properties.Property.Rooms.Room.GuestDetails.GuestDetail.FirstName}} {{bookingdata.Properties.Property.Rooms.Room.GuestDetails.GuestDetail.LastName}}</v-flex>
		<v-flex md3 xs6><strong>Age</strong></v-flex><v-flex md9 xs6>{{bookingdata.Properties.Property.Rooms.Room.GuestDetails.GuestDetail.Type}}</v-flex>
		</v-layout>
		</v-flex>
		<v-flex xs2 text-md-right text-xs-center mt-1 mb-1 perm_identity>
		<v-icon>perm_identity</v-icon>
		</v-flex>
		</v-layout>

		</div>
		</v-flex>
		</v-layout>
		
		</div>
		
		<div v-if="bookingdata.Flights.Flight.FlightExtras.FlightExtra">
		<v-layout row wrap >
		<v-flex xs12  mt-1 mr-2 pb-1 pt-1 pl-1 pr-1>
		<h3 class="mb-3 mt-2">Baggage and Flight Extras</h3>
		<div v-if="typeof bookingdata.Flights.Flight.FlightExtras.FlightExtra.length!=='undefined'">
		<v-layout row wrap pt-1 pl-2 mt-2 mr-1 whitewithborder v-for="(item, index) in bookingdata.Flights.Flight.FlightExtras.FlightExtra">
		<v-flex xs10  mt-1 mb-1>
		<v-layout mt-1 mb-1 row wrap >
		<v-flex md3 xs6><strong>Extra Type</strong></v-flex><v-flex md9 xs6>{{item.ExtraType}}</v-flex>
		<v-flex md3 xs6><strong>Description</strong></v-flex><v-flex md9 xs6>{{item.Description}}</v-flex>
		<v-flex md3 xs6><strong>Quantity</strong></v-flex><v-flex md9 xs6>{{item.Quantity}}</v-flex>
		</v-layout>
		</v-flex>
		<v-flex xs2 text-md-right text-xs-center mt-1 mb-1 perm_identity>
		<v-icon>add_shopping_cart</v-icon>
		</v-flex>
		</v-layout>

		</div>
		<div v-else>
		
		<v-layout row wrap pt-1 pl-2 mr-1 whitewithborder >
		<v-flex xs10  mt-1 mb-1>
		<v-layout mt-1 mb-1 row wrap >
		<v-flex md3 xs6><strong>Extra Type</strong></v-flex><v-flex md9 xs6>{{bookingdata.Flights.Flight.FlightExtras.FlightExtra.ExtraType}}</v-flex>
		<v-flex md3 xs6><strong>Description</strong></v-flex><v-flex md9 xs6>{{bookingdata.Flights.Flight.FlightExtras.FlightExtra.Description}}</v-flex>
		<v-flex md3 xs6><strong>Quantity</strong></v-flex><v-flex md9 xs6>{{bookingdata.Flights.Flight.FlightExtras.FlightExtra.Quantity}}</v-flex>
		</v-layout>
		</v-flex>
		<v-flex xs2 text-md-right text-xs-center mt-1 mb-1 perm_identity>
		<v-icon>add_shopping_cart</v-icon>
		</v-flex>
		</v-layout>

		</div>
		</v-flex>
		</v-layout>
		</div>
	
		
		<div v-if="bookingdata.Extras.Extra">
		<v-layout row wrap >
		<v-flex xs12  mt-1 mr-2 pb-1 pt-1 pl-1 pr-1 >
		<h3 class="mb-3 mt-2">Extras</h3>
		<div v-if="typeof bookingdata.Extras.Extra.length!=='undefined'">
		<v-layout row wrap pt-1 pl-2 mt-2 mr-1 whitewithborder v-for="(item, index) in bookingdata.Extras.Extra">
		<v-flex xs10  mt-1 mb-1>
		<v-layout mt-1 mb-1 row wrap >
		<v-flex md3 xs6><strong>Extra Type</strong></v-flex><v-flex md9 xs6>{{item.ExtraType}}</v-flex>
		<v-flex md3 xs6><strong>Extra Name</strong></v-flex><v-flex md9 xs6>{{item.ExtraName}}</v-flex>
		<v-flex md3 xs6><strong>Passengers</strong></v-flex><v-flex md9 xs6>{{item.Passengers.Passenger.length}}</v-flex>
		</v-layout>
		</v-flex>
		<v-flex xs2 text-md-right text-xs-center mt-1 mb-1 perm_identity>
		<v-icon>local_parking</v-icon>
		</v-flex>
		</v-layout>

		</div>
		<div v-else>
		
		<v-layout row wrap pt-1 pl-2 mr-1 whitewithborder >
		<v-flex xs10  mt-1 mb-1>
		<v-layout mt-1 mb-1 row wrap >
		<v-flex md3 xs6><strong>Extra Type</strong></v-flex><v-flex md9 xs6>{{bookingdata.Extras.Extra.ExtraType}}</v-flex>
		<v-flex md3 xs6><strong>Extra Name</strong></v-flex><v-flex md9 xs6>{{bookingdata.Extras.Extra.ExtraName}}</v-flex>
		<v-flex md3 xs6><strong>Passengers</strong></v-flex><v-flex md9 xs6>{{bookingdata.Extras.Extra.Passengers.Passenger.length}}</v-flex>
		</v-layout>
		</v-flex>
		<v-flex xs2 text-md-right text-xs-center mt-1 mb-1 perm_identity>
		<v-icon>local_parking</v-icon>
		</v-flex>
		</v-layout>

		</div>
		</v-flex>
		</v-layout>
		</div>	
		
		<div v-if="bookingdata.Transfers.Transfer">
		
		
		
		<v-layout row wrap mt-2 >
		<v-flex xs12  mt-1 mr-2 pb-1 pt-1 pl-1 pr-1 >	
		<h3 class="mb-3 mt-2">Resort Transfer Details</h3> 
		<v-layout row wrap pt-1 pl-2 mr-1 whitewithborder>
		<v-flex xs10  mt-1 mb-1>
		<v-layout mt-1 mb-1 row wrap >
		
		<v-flex  md3 xs6><strong>Supplier</strong></v-flex><v-flex md9 xs6>{{bookingdata.Transfers.Transfer.Sourcee}}</v-flex>		
		<v-flex  md3 xs6><strong>Reference</strong></v-flex><v-flex md9 xs6>{{bookingdata.Transfers.Transfer.SourceReference}}</strong></v-flex>			
		<v-flex  md3 xs6><strong>Vehicle</strong></v-flex><v-flex md9 xs6>{{bookingdata.Transfers.Transfer.Vehicle}} </v-flex>		
		<v-flex  md3 xs6><strong>Departing</strong></v-flex><v-flex md9 xs6>{{bookingdata.Transfers.Transfer.DepartureParentName}}  </v-flex>		
		<v-flex  md3 xs6><strong>Arriving</strong></v-flex><v-flex md9 xs6>{{(bookingdata.Transfers.Transfer.ArrivalParentName)}}  </v-flex>	
		<v-flex  md3 xs6><strong>Date and Time</strong></v-flex><v-flex md9 xs6>{{reformatDate(bookingdata.Transfers.Transfer.DepartureDate)}}{{bookingdata.Transfers.Transfer.DepartureTime}}  </v-flex>	
		</v-layout>
		</v-flex>
		<v-flex xs2 text-md-right text-xs-center mt-1 mb-1 perm_identity>
		<v-icon>local_taxi</v-icon>
		</v-flex>
		</v-layout>

		<div v-if="bookingdata.Transfers.Transfer.OneWay === 'false'">
		<v-layout row wrap pt-1 pl-2 mr-1 whitewithborder>
		<v-flex xs10  mt-1 mb-1>
		<v-layout mt-1 mb-1 row wrap >
			
				<v-flex  md3 xs6><strong>Vehicle</strong></v-flex><v-flex md9 xs6>{{bookingdata.Transfers.Transfer.Vehicle}} </v-flex>		
		<v-flex  md3 xs6><strong>Departing</strong></v-flex><v-flex md9 xs6>{{bookingdata.Transfers.Transfer.ArrivalParentName}}  </v-flex>		
		<v-flex  md3 xs6><strong>Arriving</strong></v-flex><v-flex md9 xs6>{{(bookingdata.Transfers.Transfer.DepartureParentName)}}  </v-flex>	
		<v-flex  md3 xs6><strong>Date and Time</strong></v-flex><v-flex md9 xs6>{{reformatDate(bookingdata.Transfers.Transfer.ReturnDate)}}{{bookingdata.Transfers.Transfer.ReturnTime}}  </v-flex>		
		</v-layout>
		</v-flex>
		<v-flex xs2 text-md-right text-xs-center mt-1 mb-1 perm_identity>
		<v-icon>local_taxi</v-icon>
		</v-flex>
		</v-layout>
		</div>
		
		</v-flex>
		</v-layout>			
		
		
		</div>		
		
		
		</v-flex>
		<v-flex md3  mt-2 mb-5 borderleftright pr-3 pl-3  > 

		<v-flex xs12  mt-2 mb-5>
		<h3>Confirmation Email</h3>
		<p>Send yourself another copy of your confirmation email. If you do not receive a copy via email, please contact support.</p>
		<v-btn color="mybuttoncolor" @click="ResendConfirmation">Resend Confirmation</v-btn>
		</v-flex>
		
		<v-flex xs12  mt-5 mb-5 greybgright>
		<h3>Passport Details</h3>
		<p>If you are travelling overseas please add your passport details prior to travelling.</p>
		<v-btn  color="mybuttoncolor" to="/passport">Add Details</v-btn>
		</v-flex>		
		
		<v-flex xs12  mt-5 mb-5>
		<h3>Read Our FAQ</h3>
		<p>For help and support with any of your pre-travel queries browse our frequently asked questions.</p>
		<v-btn  v-if="branddata.brand" color="mybuttoncolor" target="_blank" :href="this.branddata.brand.Brand_FAQ_Link">Read FAQs</v-btn>
		</v-flex>		
		
		<v-flex xs12  mt-5 mb-5 greybgright>
		<h3>Contact Support</h3>
		<p>If you have any queries regarding your booking, please contact our support team.</p>
		<v-btn  color="mybuttoncolor" to="/support">Contact Support</v-btn>
		</v-flex>
		
		
		</v-flex>
		
     
    </v-layout>
	
	<v-dialog v-model="confsupport" max-width="290">
      <v-card>
        <v-card-title class="headline">Success</v-card-title>
        <v-card-text>Confirmation Email Resent.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="confsupport = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>	
  <v-footer class="pa-3" color="grey" fixed>
    <v-spacer></v-spacer>
    <div>&copy; {{ new Date().getFullYear() }}</div>
  </v-footer>	
  </v-container>
  </v-container>
</template>

<script>
const axios = require('axios');
export default {
    data () {
      return {
	    
        menuItems: [
          { title: 'Dashboard', path: '/dashboard' },
          { title: 'Manage My Booking', path: '/mybooking' },
          { title: 'Add Passport Details', path: '/passport' },
          { title: 'Contact Support', path: '/support' },
		   { title: 'Logout', path: '/logout' }
        ],
		bookingdata: {},
		MealBasis: [{t:'Na'},{t:'Room Only'},{t:'Self-catering'},{t:'Bed and Breakfast'},{t:'Half Board'},{t:'Full Board'},{t:'All Inclusive'},{t:'Chalet Board'},{t:'Half Board Ski Pass'}, {t:'Bed and Breakfast with Ski Pass'}, {t:'Self-catering with Ski Pass'}],
		branddata: {},
		confsupport:false
		
     }
    },
	created () {
		if (this.isAuthenticated) {
		this.buildBooking(JSON.parse(localStorage.getItem("brefcldata")))
		}
	},
	computed: {
      isAuthenticated () {
		//console.log(this.$store.getters.isAuthenticated);
        return this.$store.getters.isAuthenticated
      },

	  bookingnumber () {
		  if (this.isAuthenticated) {
			return localStorage.getItem("brefcl")
		  } else {
			return null
		  }
		}
	  
    },
	methods: {
    buildBooking (data) {
      this.bookingdata = data
	  //console.log("aa="+typeof this.bookingdata.Flights.Flight.FlightSectors.FlightSector.length);
	  //console.log("bb="+typeof this.bookingdata.Flights.Flight.FlightPassengers.FlightPassenger.length);
    },
		  ResendConfirmation()
	  {
		this.$store.dispatch('ResendConfirmation', { bookingreference: this.bookingnumber })
		this.confsupport=false
		this.$swal('Success','A copy of your confirmation Email has been successfully sent to <br/><br/><strong>'+this.bookingdata.LeadCustomer.CustomerEmail+'</strong><br/><br/>If you do not receive a copy via email, please check your junk folder just in case. If you are still having trouble please <a href="/support">contact support</a>.','success')
	  },
	reformatDate(s) {
   var b = s.split('T');
  var c = b[0];
  var d = c.split('-');
  return d[2]+"/"+d[1]+"/"+d[0];
	},
	reformatDaterfc(s) {
  
  var b = s.split('T');
  var c = b[0];
  return c;
	}
	
  },
  
  mounted() {
		
		if(localStorage.getItem("branddata")===null)
		{
		axios.get("https://brands.msa.airportdirecttravel.com/getbrandfromcodeformmb?brand_code="+this.bookingdata.BrandCode)
    .then(response => {
		this.branddata = JSON.parse(response.request.response); 
		//console.log("NLS"+this.branddata);
		localStorage.setItem("branddata",JSON.stringify(this.branddata));
		})
		}
		else{
		this.branddata = JSON.parse(localStorage.getItem("branddata"));
		//console.log("LS"+this.branddata.brand.Brand_FAQ_Link);
		}
	
	
		}
	
  }

</script>